import React, { useEffect, useRef, useState } from "react";
import "./CohortPage.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Filters from "./CohortFilter/Filters";
import CohortList from "./CohortList/CohortList";
import CohortView from "./CohortView/CohortView";
import AdditionalInstitutions from "./CohortFilter/AdditionalInstitutions";
import exportimages from "../../../assets/images/exportImages";
import {
  downloadFHSReportRTK,
  useGetDownloadReportQuarterListQuery,
  useGetFHSDataBasedOnQuarterQuery,
} from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportRTK";
import { setSelectedQuarter } from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import { setSelectedCohort } from "../../../rtk-query/features/cohort/cohortSlice";
import { SUBSCRIPTION } from "../../../utils/global";

const ConfirmModal = ({ show, onConfirm, onCancel }) => {
  if (!show) return null;
  const selectedQuarter = useSelector(
    (state) => state?.ewiReducer?.selectedQuarter,
  );

  const { data: quarterListDropdown } = useGetDownloadReportQuarterListQuery();

  return (
    <div className="modal-overlay ">
      <div className="modal-box">
        {/* <h3>Leaving this page?</h3> */}
        <p>
          The selected cohort is available{" "}
          {quarterListDropdown?.data?.[0].label}. You are currently viewing{" "}
          {selectedQuarter?.label}. Would you like to switch to{" "}
          {quarterListDropdown?.data?.[0].label}?
        </p>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onCancel}>
            No
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

const CohortPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.authReducer);
  const [isAddRemoveInProgress, setIsAddRemoveInProgress] = useState(false);
  useEffect(() => {
    if (isAddRemoveInProgress) {
      setTimeout(() => setIsAddRemoveInProgress(false), 1500);
    }
  }, [isAddRemoveInProgress]);
  const orgReducer = useSelector((state) => state?.orgReducer);
  const navigationHistoryReducer = useSelector(
    (state) => state.navigationHistoryReducer,
  );

  const cohortApplied = useSelector(
    (state) => state?.cohortReducer?.cohortApplied,
  );

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const selectedQuarter = useSelector(
    (state) => state?.ewiReducer?.selectedQuarter,
  );

  const selectedCohortOnFHS = useSelector(
    (state) => state?.ewiReducer?.selectedCohortOnFHS,
  );

  const {
    data: FHSDataBasedOnQuarter,
    isFetching,
    isLoading,
  } = useGetFHSDataBasedOnQuarterQuery({ quarter: selectedQuarter?.code }, {});

  const { data: quarterListDropdown } = useGetDownloadReportQuarterListQuery();

  const [showModal, setShowModal] = useState(false);
  const [nextAction, setNextAction] = useState(null);

  const t = FHSDataBasedOnQuarter?.cohortList?.find(
    (i) => i?.uid === selectedCohort?.uid,
  );

  const shouldBlockNavigation = !FHSDataBasedOnQuarter?.cohortList?.find(
    (i) => i?.uid === selectedCohort?.uid,
  )
    ? quarterListDropdown?.data?.[0]?.label !== selectedQuarter?.label
    : false;

  const handleBackNavigation = () => {
    if (shouldBlockNavigation) {
      setShowModal(true);
    } else {
      navigate(
        `/bank/health-analysis/report/${orgReducer?.selectedFI?.idrssd}/financial-health-score`,
      );
    }
  };

  const handleConfirm = () => {
    dispatch(setSelectedQuarter(quarterListDropdown?.data?.[0]));
    setShowModal(false);
    navigate(
      `/bank/health-analysis/report/${orgReducer?.selectedFI?.idrssd}/financial-health-score`,
    );
  };

  const handleCancel = () => {
    dispatch(setSelectedCohort(selectedCohortOnFHS));
    dispatch(
      downloadFHSReportRTK.util.invalidateTags(["FHSDataBasedOnQuarter"]),
    );
    setShowModal(false);
    navigate(
      `/bank/health-analysis/report/${orgReducer?.selectedFI?.idrssd}/financial-health-score`,
    );
  };

  const shouldBlockRef = useRef(shouldBlockNavigation);

  useEffect(() => {
    shouldBlockRef.current = shouldBlockNavigation;
  }, [shouldBlockNavigation]);

  useEffect(() => {
    const handlePopState = () => {
      if (shouldBlockRef.current) {
        window.history.pushState(null, "", window.location.pathname);

        const confirmLeave = window.confirm(
          `The selected cohort is available ${quarterListDropdown?.data?.[0].label}. You are currently viewing ${selectedQuarter?.label}. Would you like to switch to ${quarterListDropdown?.data?.[0].label}?`,
        );

        if (confirmLeave) {
          handleConfirm();
        } else {
          handleCancel();
        }
      } else {
        navigate(
          `/bank/health-analysis/report/${orgReducer?.selectedFI?.idrssd}/financial-health-score`,
        );
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, quarterListDropdown, selectedQuarter, orgReducer]);

  return (
    <div className="dashboardContainer position-relative " id="cohort-page">
      <div className="row p-4">
        <div className="col-md-5 col-sm-12  ">
          <div className="custom-theme pageTitle">
            <h3 className="text-dark fs-page-title fw-bolder lh-lg mb-1 dashboard-title">
              Cohort Management
            </h3>
          </div>
          {/* <CustomBreadcrumb campaignId={campaignId} /> */}
          <div
            className="custom-theme pageSubTitle fs-7 text-868687 "
            style={{ fontSize: "12px" }}
          >
            <span
              style={{
                display: navigationHistoryReducer.isPathFromCluster
                  ? "none"
                  : "inline-block",
              }}
            >
               {authReducer?.userData?.subscription !== SUBSCRIPTION.ANALYST && (
                <>
                  <Link
                    id="dashboard_link_to_cohort"
                    to={`/bank/health-analysis/report/${orgReducer?.healthAnalysisID?.uid
                        ? orgReducer?.healthAnalysisID?.uid
                        : "no-analysis-id"
                      }`}
                    style={{ color: "#868687" }}
                  >
                    <span className="fs-breadcrumbs ms-1">Dashboard</span>
                  </Link>

                  {" > "}
                </>
              )}
            </span>
            <span>
              <Link
                id="fhs_details_link_to_cohort"
                // to={`/bank/campaign-management/create-campaign?consumerID=${sessionStorage.getItem(
                //   "campaignConsumerID",
                // )}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleBackNavigation();
                }}
                style={{
                  color: "#868687",
                  // display: navigationHistoryReducer.isPathFromCluster
                  //   ? "inline-block"
                  //   : "none",
                }}
              >
                <span className="fs-breadcrumbs ms-1">
                  Financial Performance Overview
                </span>
              </Link>
              {" > "}
              {"  "}
              <Link
                id="graph_link_to_report"
                to={`/bank/cohort-management`}
                style={{
                  color: "#868687",
                  // display: navigationHistoryReducer.isPathFromCluster
                  //   ? "none"
                  //   : "inline-block",
                  // pointerEvents:
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.QUEUE_CAMPAIGN ||
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.ACTIVE_CAMPAIGN ||
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.COMPLETE_CAMPAIGN
                  //     ? "none"
                  //     : "auto",
                }}
              >
                <span className="text-4b4b4b fs-breadcrumbs text-decoration-underline ms-1">
                  Cohort Management
                </span>
              </Link>
            </span>
          </div>
        </div>
        <div
          className="col-md-7 col-sm-12 text-end mb-4"
          style={{ fontWeight: "normal!important" }}
        >
          <button
            type="button"
            id="kt_login_password_reset_form_cancel_button"
            onClick={() => {
              handleBackNavigation();
            }}
            className="mr-4 btn btn-outline-primary border-primary btn-bond mb-2 mt-2 "
          >
            <img
              alt="back-arrow"
              src={exportimages?.backArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImage"
            />
            <img
              alt="back-arrow"
              src={exportimages?.hoverBackArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImageHover"
            />
            <span
              className="me-3 fs-btn-text fs-xxl-6 "
              style={{ fontWeight: "normal" }}
            >
              Back{" "}
            </span>
          </button>

          {/* {hasPermission(PRIVILEGES.EDIT_EMAIL_CAMPAIGN) && (
            <button
              type="button"
              id="kt_login_password_reset_form_cancel_button"
              onClick={() => {
                navigate(
                  `/bank/campaign-management/edit-campaign/${campaignId}`,
                );
              }}
              disabled={
                hasSubscription(PRIVILEGES.EDIT_EMAIL_CAMPAIGN)
                  ? emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.QUEUE_CAMPAIGN ||
                    emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.ACTIVE_CAMPAIGN ||
                    emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.COMPLETE_CAMPAIGN
                  : true
              }
              className="btn btn-primary border-primary btn-bond mb-2 mt-2 "
            >
              <span className="fs-btn-text fw-normal">Edit Campaign</span>
            </button>
          )} */}
        </div>
      </div>
      <div
        className="row g-8 px-8 cohort-page"
      // style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div className="col-md-8 cohort-filter-section">
          <div className="row">
            <div className="col-md-6">
              <div className="outline-card">
                <CohortList />
              </div>
            </div>
            <div className="col-md-6">
              <div className="outline-card" style={{ border: "none" }}>
                <div className="card border mb-8">
                  <Filters
                    setIsAddRemoveInProgress={setIsAddRemoveInProgress}
                  />
                </div>
                {(selectedCohort != null || cohortApplied?.cohort != null) && (
                  <div className="card border">
                    <AdditionalInstitutions
                      isAddRemoveInProgress={isAddRemoveInProgress}
                      setIsAddRemoveInProgress={setIsAddRemoveInProgress}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 cohort-view-section">
          <div className="col-md-12">
            <CohortView
              isAddRemoveInProgress={isAddRemoveInProgress}
              setIsAddRemoveInProgress={setIsAddRemoveInProgress}
            />
          </div>
        </div>
      </div>
      <ConfirmModal
        show={showModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default CohortPage;
